import "./tarifsTextNotes.css";

import TarifsTextCartouche from "./tarifsTextCartouche";

function TarifsTextNotes({ notes = "" }) {
  const content = (
    <div className="tarifs-text-notes">
      <div className="tarifs-text-notes-note">Notes :</div>
      {notes}
    </div>
  );
  return <TarifsTextCartouche bTop="1%">{content}</TarifsTextCartouche>;
}

export default TarifsTextNotes;
